import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取合作商品列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPartnerGoods(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/partnerGoods.listPartnerGoods',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取合作商列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPartnerPool(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/partner.listPartnerPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}